import * as React from "react";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";

export default function CustomSearchKeywordDropdown({ row }) {

    const parsedata = JSON.parse(row?.custom_query)
    const joinedData = parsedata?.prospects?.map(i => (`${i?.first_name} ${i?.last_name}`)) || []

    const allData = [
        ...(parsedata?.organization?.org_name ? [parsedata.organization.org_name] : []),
        ...(parsedata?.keywords || []),
        ...(joinedData || []),
        ...(parsedata?.industries || []),
        ...(parsedata?.states || []),
    ];

    const firstCategory = allData?.[0]?.trim();
    const remainingCategoriesCount = allData?.length === 1 && allData?.[0] !== "" ? null : allData?.length > 1 ? `+${allData.length - 1}` : "Not Available"
    const categoriesArray = allData
    const [open, setOpen] = React.useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <div className="ContactDetailList-dropdown-industry-track">
                <List
                    sx={{
                        width: "100%",
                        maxWidth: 360,
                        bgcolor: "background.paper",
                    }}
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                    className="list-main-container"
                    onMouseEnter={handleOpen}
                    onMouseLeave={handleClose}
                >
                    <ListItemButton className="list-button-item-start">
                        <ListItemText className="list-text-item" />
                        <div>
                            {firstCategory && remainingCategoriesCount ? (
                                <p className="">

                                    {firstCategory ? firstCategory.length > 10 ? `${firstCategory?.substr(0, 10)}...` : firstCategory : "Not Available"}
                                    {remainingCategoriesCount}
                                </p>
                            ) : (
                                <p className="">
                                    {firstCategory?.substr(0, 10)} {remainingCategoriesCount}
                                </p>
                            )}

                            {/* <p className="industry-text-dropdown-head-main-propect">{firstCategory.substr(0,10) + "..."} {remainingCategoriesCount}</p> */}
                        </div>
                    </ListItemButton>
                    <Collapse in={open} timeout="auto" unmountOnExit className="tracking-height">
                        <List
                            component="div"
                            disablePadding
                            className="dropdownbox-main-container-tracking"
                        >
                            {categoriesArray?.map((item, index) => (
                                <ListItemButton
                                    key={index}
                                    sx={{ pl: 4 }}
                                    className="buttons-of-the-list-item-track"
                                >
                                    <ListItemText className="list-text-item" />
                                    <p className="industry-detail-dropdowntext-track">{item}</p>
                                </ListItemButton>
                            ))}
                        </List>
                    </Collapse>
                </List>
            </div>
        </>
    );
}